import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Standardized loading spinner components
 * 
 * Use these standard sizes for consistency across the app:
 * 
 * Standard sizes:
 * - <CircularProgress size={100} />  - Page-level loading (backdrops, full page)
 * - <CircularProgress size={40} />   - Inline content loading (lists, sections)
 * - <CircularProgress size={20} />   - Small UI elements (table cells, buttons)
 * 
 * All spinners automatically use the primary theme color.
 * Use the preset components below for common patterns with proper layout.
 */
export const StandardLoading = ({ 
    size = 80, 
    centered = true, 
    color = 'primary',
    fullScreen = false,
    sx = {} 
}) => {
    const containerSx = {
        display: 'flex',
        justifyContent: centered ? 'center' : 'flex-start',
        alignItems: 'center',
        ...(fullScreen && {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999
        }),
        ...sx
    };

    return (
        <Box sx={containerSx}>
            <CircularProgress 
                size={size} 
                color={color}
            />
        </Box>
    );
};

// Preset variants for common use cases
export const PageLoading = (props) => (
    <StandardLoading size={100} centered={true} color="primary" {...props} />
);

export const InlineLoading = (props) => (
    <StandardLoading size={40} centered={true} color="primary" sx={{ mt: 2 }} {...props} />
);

export const SmallLoading = (props) => (
    <StandardLoading size={20} centered={false} color="primary" {...props} />
);